const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Celebrity%20couple%20walking%20on%20red%20carpet%20holding%20hands%2C%20paparazzi%20flash%20lights%2C%20elegant%20evening%20wear%2C%20dramatic%20lighting%2C%20editorial%20photography%20style%2C%20warm%20golden%20tones%2C%20luxurious%20atmosphere%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=card-chigua-01&orientation=landscape',
    tag: '恋情实锤',
    title: '当红顶流深夜密会被拍，疑似新恋情浮出水面',
    summary: '近日有媒体拍到某顶流艺人与神秘女子深夜同返公寓，举止亲密引发恋情猜测。据知情人士透露，两人已交往数月。',
    hot: '9.8万',
    time: '2小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=TV%20show%20recording%20studio%20with%20hosts%20arguing%20dramatically%2C%20bright%20stage%20lights%2C%20audience%20reactions%2C%20reality%20show%20atmosphere%2C%20tense%20moment%2C%20professional%20broadcast%20setup%2C%20vibrant%20colorful%20lighting&width=800&height=600&seq=card-chigua-02&orientation=landscape',
    tag: '综艺翻车',
    title: '热门综艺录制现场爆发激烈争执，导演紧急叫停',
    summary: '某S+级综艺最新一期录制过程中，两位常驻嘉宾因游戏环节产生严重分歧，现场气氛一度紧张到导演组介入调解。',
    hot: '7.2万',
    time: '4小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Fashion%20award%20ceremony%20red%20carpet%20event%2C%20celebrities%20in%20stunning%20gowns%20and%20suits%2C%20photographers%20crowd%2C%20glamorous%20atmosphere%2C%20elegant%20venue%20lighting%2C%20luxurious%20designer%20fashion%2C%20warm%20golden%20hour%20glow&width=800&height=600&seq=card-chigua-03&orientation=landscape',
    tag: '红毯造型',
    title: '年度盛典红毯生图流出，谁的状态最能打？',
    summary: '本年度最受瞩目的颁奖盛典红毯环节高清生图曝光，多位艺人真实状态引发网友热议，有人赢麻有人翻车。',
    hot: '6.5万',
    time: '6小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Music%20concert%20stage%20with%20colorful%20light%20show%2C%20massive%20crowd%20with%20light%20sticks%2C%20performer%20silhouette%2C%20energetic%20atmosphere%2C%20live%20music%20event%2C%20dramatic%20stage%20effects%2C%20neon%20lights%2C%20concert%20photography&width=800&height=600&seq=card-chigua-04&orientation=landscape',
    tag: '音乐现场',
    title: '顶流歌手巡回演唱会突发意外，现场歌迷炸锅',
    summary: '某天王级歌手巡回演唱会首站突发设备故障，演出中断近20分钟。但随后的即兴清唱环节反而成为全场最大惊喜。',
    hot: '5.8万',
    time: '8小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%2C%20director%20chair%20and%20camera%20equipment%2C%20movie%20production%20set%20with%20lights%2C%20crew%20members%20working%2C%20cinematic%20atmosphere%2C%20professional%20filmmaking%20environment%2C%20dramatic%20set%20lighting&width=800&height=600&seq=card-chigua-05&orientation=landscape',
    tag: '影视剧透',
    title: '年度巨制电影路透照外泄，剧情走向提前揭秘',
    summary: '备受期待的年度大片拍摄现场路透照流出，关键场景造型曝光。业内人士分析剧情或将出现重大反转。',
    hot: '4.3万',
    time: '10小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Business%20contract%20signing%20ceremony%2C%20elegant%20office%20setting%2C%20two%20parties%20shaking%20hands%2C%20professional%20atmosphere%2C%20luxurious%20interior%2C%20warm%20lighting%2C%20corporate%20event%2C%20clean%20modern%20design&width=800&height=600&seq=card-chigua-06&orientation=landscape',
    tag: '合约风波',
    title: '知名艺人经纪合约到期，多家公司开启抢人大战',
    summary: '某一线艺人与原经纪公司合约即将到期，据传已有三家头部公司抛出橄榄枝，签约金额或刷新行业纪录。',
    hot: '3.9万',
    time: '12小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20phone%20screen%20with%20post%20going%20viral%2C%20notification%20alerts%2C%20trending%20hashtag%2C%20modern%20smartphone%20close%20up%2C%20dark%20background%20with%20warm%20glow%2C%20digital%20content%20creation%2C%20online%20drama%20concept&width=800&height=600&seq=card-chigua-07&orientation=landscape',
    tag: '社交风暴',
    title: '艺人深夜发文后又秒删，粉丝截图引爆全网讨论',
    summary: '某流量艺人凌晨发布意味深长的动态后迅速删除，但已被手快粉丝截图保存，内容引发全平台刷屏讨论。',
    hot: '3.1万',
    time: '14小时前',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12">
            <div>
              <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
                实时快讯
              </span>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-2">
                今日吃瓜快讯
              </h2>
              <p className="text-foreground-600 text-sm">
                最新最热的娱乐八卦，每一条都值得细品
              </p>
            </div>
            <a
              href="#ranking"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              查看更多 <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
            {cards.slice(0, 7).map((card) => (
              <article
                key={card.title}
                className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 overflow-hidden transition-all duration-200 cursor-pointer"
              >
                <div className="relative overflow-hidden aspect-[4/3]">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                    loading="lazy"
                    onError={(e) => {
                      (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                    }}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-semibold">
                      {card.tag}
                    </span>
                  </div>
                  <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 rounded-full bg-black/50 text-white text-xs">
                    <i className="ri-fire-line text-xs"></i>
                    {card.hot}
                  </div>
                </div>
                <div className="p-5 flex-1 flex flex-col">
                  <h3 className="font-heading font-bold text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {card.title}
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed line-clamp-3 mb-4 flex-1">
                    {card.summary}
                  </p>
                  <div className="flex items-center justify-between pt-3 border-t border-background-200">
                    <span className="text-foreground-400 text-xs flex items-center gap-1">
                      <i className="ri-time-line"></i> {card.time}
                    </span>
                    <span className="text-primary-600 text-xs font-medium flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                      阅读全文 <i className="ri-arrow-right-s-line"></i>
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}